import React from 'react';
import {useEffect} from 'react';
import Button from '../basics/Button';
import icon_caution from '../assets/img/icon_caution.svg';
import iconClose from '../assets/img/icon_close.svg';
import '../css/components/Salir.css';

export default function Salir(props) {
  const {mostrar, cerrarModal} = props;

  useEffect(() => {
    if (cerrarModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [cerrarModal]);

  function handleClick() {
    window.location.href = 'https://www.bbva.pe/personas/productos/cuentas/ahorro.html';
  }

  return (
    <div className='md:w-modalDesktop w-auto p-4'>
      <div className={mostrar ? 'flex justify-between pt-2 pb-2' : 'flex items-center justify-between pt-2 pb-2 text-sphericaPrimary'}>
        <div>
          <img src={icon_caution} alt='imageCaution' width={mostrar ? 'auto' : '50px'}></img>
        </div>     
        <div className='flex justify-end'>
          <img className='cursor-pointer w-8 h-8' alt='close' src={iconClose} onClick={() => cerrarModal()}></img>
        </div>
      </div>
      <div className='text-sphericaPrimary'>
        <div className='font-bbvaTiempos pt-4 salir-titulo'>
          ¿Deseas salir?
        </div>   
        <div className='pt-2 pb-4 salir-descripcion'>
          Al hacerlo, será necesario que ingreses tu información de nuevo.
        </div>
        <div className='flex flex-col md:flex-row gap-4'>
          <Button className='button--primary' onClick={handleClick}>Salir</Button>
          <Button className='btn-sphericaSecondary' onClick={() => cerrarModal()}>Continuar con el proceso</Button>
        </div>
      </div>
    </div>
  );
}
